import React, { PureComponent, ReactNode } from 'react'
import './IndexPublicStats.scss'
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { IPermit } from '../StrapiService'
import { LinkContainer } from 'react-router-bootstrap'
import { TFunction } from 'i18next'

interface Props {
  permits: IPermit[]
  t: TFunction;
}

class IndexPublicStats extends PureComponent<Props> {
  defaultPermitId(id: string){
    return id.replace('.1', '').replace('.2', '').replace('.3', '')
  }

  get permitIds() {
    return [...new Set(this.props.permits.map(p => this.defaultPermitId(p.permitId)))]
  }
  permitBlock(id: string) {
    let permit = this.props.permits.find(p => p.permitId === id || p.permitId === id + '.1')
    if  (permit) {
      return (
        <LinkContainer to={permit.statisticsUrl} key={`permit-block-${permit.permitId}`}>
          <div className="state-permit">
            <div className="state-popover">{permit.statisticsButtonTitle}</div>
            <div className="container d-flex flex-column align-items-center justify-content-center">
              <img src={`${process.env.PUBLIC_URL}${permit.iconUrl}`} className="icon" alt=""/>
              <span className="pt-2">{this.defaultPermitId(permit.permitId)}</span>
            </div>
          </div>
        </LinkContainer>
      )
    }
    return (<></>)
  }
  render(): ReactNode {
    return (
      <Row className="index-public-stats">
        <Col md="5">
          <div className="text-block d-flex flex-column">
            <p className="mb-0 flex-grow-1">
              {this.props.t("home.public.infoText1")} <span className="d-inline d-md-none">{this.props.t("home.public.infoText2")} </span>{this.props.t("home.public.infoText3")}
            <i className="flaticon2-line-chart display-4 ml-4"></i>
            </p>
            <Link className="link mt-3" to="/public-info">{this.props.t("home.public.openPublicDataPage")}</Link>
          </div>
        </Col>
        <Col md="7" className="permits-block">
          {
            this.permitIds.map((permitId, i) => (
              this.permitBlock(permitId)
            ))
          }
          {
            this.permitIds.length%2 === 1 && <LinkContainer to="public-info" key={`permits-block-general`}>
            <div className="state-permit general">
              <div className="state-popover">{this.props.t("home.public.openStatsPage")}</div>
              <div className="container d-flex flex-column align-items-center justify-content-center">
                <i className="la la-chevron-right icon"></i>
              </div>
            </div>
          </LinkContainer>
          }
        </Col>
      </Row>
    )
  }
}

export default IndexPublicStats
